import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3e6ef930&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "../../../node_modules/bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=3e6ef930&scoped=true&lang=css&"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=3e6ef930&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ef930",
  null
  
)

export default component.exports